import { Action, createReducer, on } from '@ngrx/store';
import { SearchActions } from '../actions';
import { initState, SearchState } from '../states/search.states';

export const searchFeatureKey = 'search';

export const searchReducers = createReducer(
  initState,
  on(SearchActions.basicSearch, (state, action) => ({ ...state, basicSearch: action.basicCriteria })),
  on(SearchActions.branches, (state, action) => ({ ...state, branches: action.branches })),
  on(SearchActions.customers, (state, action) => ({ ...state, customers: action.customers })),
  on(SearchActions.suppliers, (state, action) => ({ ...state, suppliers: action.suppliers })),
  on(SearchActions.locationsFrom, (state, action) => ({ ...state, locationsFrom: action.locationsFrom })),
  on(SearchActions.locationsTo, (state, action) => ({ ...state, locationsTo: action.locationsTo })),
  on(SearchActions.resetState, (state, action) => {
    state.basicSearch = null;
    state.branches = null;
    state.customers = null;
    state.locationsFrom = null;
    state.locationsTo = null;
    state.suppliers = null;
    return state;
  }),

);

export function searchReducer(state: SearchState | undefined, action: Action) {
  return searchReducers(state, action);
}
